export default "__VITE_ASSET__4f947ea1__"